import { gql, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadTable } from "../../Components";
import BidDetails from "../../Components/FormComponents/AddLoad/Bidding";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import SPRelatedLoads from "./SPRelatedLoads";
import "./SearchSP.scss";
import WarningModal from "./WarningModal";

const Get_All_SP = gql`
  query SearchSpByLoadID($LoadID: ID) {
    SearchSpByLoadID(LoadID: $LoadID) {
      _id
      Unique_Id
      Related_SP {
        _id
        SP_ID
        SP_ID_Info {
          _id
          Unique_Id

          mobileNumber

          FullName

          Company_Name
        }
        Accountdata {
          _id
          Unique_Id
          UserId
          Proprietor_Name
          Business_Name
          Business_City
          Mobile_Number
          Emergency_Mobile_Number
          Mobile_Number_Two
          Business_Mobile_Number
          Business_Mobile_Number_Two
          Business_Mobile_Number_Three
          Name
          Is_Verified
          Transporter_Type
          Directory_NonDirectory
          KYC_Complete
          Not_Intrested
          Not_Intrested_Remark
          createdAt
          updatedAt
        }
        Status
        Comment
      }
    }
  }
`;

const REFETCH_ALL_SP_LOAD = gql`
  mutation CreateRelatedSearchSPForWithLoadId($LoadId: ID) {
    CreateRelatedSearchSPForWithLoadId(LoadId: $LoadId) {
      _id
      Unique_Id
      Related_SP {
        _id
        SP_ID
        SP_ID_Info {
          _id
          Unique_Id
          mobileNumber
          FullName
          Company_Name
        }
        Accountdata {
          _id
          Unique_Id
          UserId
          Proprietor_Name
          Business_Name
          Business_City
          Mobile_Number
          Emergency_Mobile_Number
          Mobile_Number_Two
          Business_Mobile_Number
          Business_Mobile_Number_Two
          Business_Mobile_Number_Three
          Alternate_Mobile_Number
          Name
          Is_Verified
          Transporter_Type
          Directory_NonDirectory
          KYC_Complete
          Not_Intrested
          Not_Intrested_Remark
          createdAt
          updatedAt
        }
        Status
        Comment
      }
    }
  }
`;

const Get_All_Bids_SP = gql`
  query BidDetailsByLoadId($createInput: RequiredBidDetails) {
    BidDetailsByLoadId(createInput: $createInput) {
      _id
      LoadId
      UserId {
        _id
        Unique_Id
        FullName
        Company_Name
        mobileNumber
      }
      Accountdata {
        _id
        Unique_Id
        UserId
        Proprietor_Name
        Business_Name
        Mobile_Number
        Emergency_Mobile_Number
        Mobile_Number_Two
        Business_Mobile_Number
        Business_Mobile_Number_Two
        Business_Mobile_Number_Three
        Alternate_Mobile_Number
        Is_Verified
        Transporter_Type
        Directory_NonDirectory
        KYC_Complete
        Not_Intrested
        Not_Intrested_Remark
        createdAt
        updatedAt
      }
      Price
      Unique_Id
      No_Of_Vehicle
      Confirm_Qty
      Trip_Bookings
      Bid_Note
      Bid_History
      Rank
      createdAt
      updatedAt
    }
  }
`;

const EDIT_LOAD = gql`
  mutation EditRelatedSPForLoads($CreateInput: EditRelatedSpInput) {
    EditRelatedSPForLoads(CreateInput: $CreateInput) {
      message
    }
  }
`;
// Queries =>
// `useQuery(Get_All_SP, {...})` and `useQuery(Get_All_Bids_SP, {...})` are GraphQL queries to fetch all service providers and all bids for service providers, respectively.
// The `variables` object defines the query parameters, and `fetchPolicy: "network-only"` ensures the data is fetched from the network rather than the cache.
// The `context` defines custom headers for the request.
const SearchSP = ({ show, LoadId, setShowModal }) => {
  const { data, refetch, error, loading } = useQuery(Get_All_SP, {
    variables: {
      LoadID: LoadId,
    },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const { data: bidsSPs } = useQuery(Get_All_Bids_SP, {
    variables: {
      createInput: {
        id: LoadId,
        sort: 1,
        sortBy: "Rank",
      },
    },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [loadingState, setLoading] = useState(true);
  const [openItems, setOpenItems] = useState(show);
  const [alldata, setalldata] = useState<any>([]);
  const [showWarningModal, setShowWarningModal] = useState(false);

  // Mutations =>
  // `useMutation(EDIT_LOAD, {...})` and `useMutation(REFETCH_ALL_SP_LOAD, {...})` are mutations to edit a load and refetch all service providers for a load, respectively.
  // The context for these mutations also includes custom headers.

  const [editLoad] = useMutation(EDIT_LOAD, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [refetchAllSP, { loading: researchSPloading }] = useMutation(REFETCH_ALL_SP_LOAD, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  // State management:
  // Various `useState` hook are used to manage component state.
  // `openItems`, `alldata`, `showWarningModal`, `combinedData`, `sendData`, `showBidModal`, `RelatedSPs`, `RespId`, `allSPsStatus`, `selectedFirst`, `showRelatedLoadModal`, `spId`, `allBidCompletedSPs` are all state variables used to control UI elements, store data, and manage modal states.
  const [combinedData, setCombinedData] = useState<any>([]);
  const [showBidModal, setShowBidModal] = useState(false);
  const [RelatedSPs, setRelatedSPs] = useState(null);
  const [RespId, setReSpId] = useState("");
  const [allSPsStatus, setAllSPsStatus] = useState<any>([]);
  const [selectedFirst, setSelectedFirst] = useState();
  const [showRelatedLoadModal, setShowRelatedLoadModal] = useState(false);
  const [spId, setSpId] = useState({});
  const dispatch = useDispatch();
  const SelectedRowsData = useSelector((store: any) => store?.UniqueTableReducer?.SearchSp_Main_Table);
  const [allBidCompletedSPs, setAllBidCompletedSPs] = useState([]);

  // handleRefetchAllSP This function calls the `refetchAllSP` mutation to refresh the list of service providers for a given load ID.
  // It also handles refreshing the data by calling `refetch` and managing modal visibility.
  let handleRefetchAllSP = () => {
    refetchAllSP({
      variables: {
        LoadId: LoadId,
      },
    })
      .then((res) => {
        refetch({
          variables: {
            LoadID: LoadId,
          },
        });
        setShowWarningModal(false);
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };
  // handlebidModalfuc : Opens a bid modal for a specific servic provider it user redux's `dispatch` to update the application state with the selected.
  //  user's information and sets local state to show the bid modal.

  let handleBidModalfuc = (spid, spname) => {
    dispatch({
      type: "SearchMasterData",
      payload: {
        UserId: { _id: spid, FullName: spname },
      },
    });
    setSpId({ UserId: spname });
    setShowBidModal(true);
  };
  // sets the RespId state and shows a modal related to loads for a specific service provider.
  let handleOpenRelatedLoadModal = (SP_ID) => {
    setReSpId(SP_ID);
    setShowRelatedLoadModal(true);
  };
  // handleStatuschange updates the allSpsStatus state with the new status of  a service provider.
  // This function is used in a select dropdown to manage the status of service providers.
  let handleStatusChange = (SP_ID: any, Status: String) => {
    setAllSPsStatus((prevArray) => {
      const newArray = [...prevArray];
      const foundIndex = newArray.findIndex((item) => item.id === SP_ID);

      if (foundIndex >= 0) {
        newArray[foundIndex].val = Status;
      } else {
        newArray.push({ SP_ID, Status });
      }

      return newArray;
    });
  };

  //Here hooks that takes the combining data form selected rows with all data when either changes, and transforming the data from the
  // bidsSps and data queries to a format suitable for display in the UI.
  useEffect(() => {
    if (SelectedRowsData?.Selected_Rows) {
      let newData = [...SelectedRowsData?.Selected_Rows, ...alldata];
      newData = newData?.filter((item, index, self) => index === self.findIndex((t) => t._id === item._id));
      setCombinedData(newData);
    }
  }, [SelectedRowsData?.Selected_Rows, alldata]);

  // Here it is displaying and interaction with data related to service providers, including handling bids,
  // showing modals for additional information, and changing statuses, It uses both Bootstrap and custom styles for rendering.
  useEffect(() => {
    if (bidsSPs) {
      let modifiedData = bidsSPs.BidDetailsByLoadId.map((e) => {
        let obj = {
          Business_Name: e?.Accountdata?.Business_Name ? e?.Accountdata?.Business_Name : "",
          Proprietor_Name: e?.Accountdata?.Proprietor_Name ? e.Accountdata.Proprietor_Name : "",
          Personal_Mobile_Number: e?.Accountdata?.Mobile_Number ? e?.Accountdata?.Mobile_Number : "",
          Business_Mobile_Number: e?.Accountdata?.Business_Mobile_Number ? e?.Accountdata?.Business_Mobile_Number : "",
          "Broker/Fleetowner": e?.Accountdata?.Transporter_Type ? e?.Accountdata?.Transporter_Type : "",
          "Directory/ Non-Directory": e?.Accountdata?.Directory_NonDirectory
            ? e?.Accountdata?.Directory_NonDirectory
            : "",
          KYC: e?.Accountdata?.KYC_Complete,
          verified: e?.Accountdata?.Is_Verified,
          Rank: e?.Rank,
          Bid_Price: e?.Price,
          Bid_Now: (
            <a
              href="#"
              style={{ color: "blue", textDecoration: "none" }}
              onClick={() => handleBidModalfuc(e?.UserId?._id, e?.UserId?.FullName)}
            >
              {" "}
              Bid Now
            </a>
          ),
        };
        return obj;
      });
      setAllBidCompletedSPs(modifiedData);
    }
  }, [bidsSPs]);

  useEffect(() => {
    setLoading(true);
    if (data) {
      let modifiedData = data?.SearchSpByLoadID[0]?.Related_SP?.map((e) => {
        let obj = {
          _id: e._id,
          Business_Name: e?.Accountdata?.Business_Name ? e?.Accountdata?.Business_Name : "",
          Business_City: e?.Accountdata?.Business_City ? e?.Accountdata?.Business_City : "",
          Proprietor_Name: e?.Accountdata?.Proprietor_Name ? e.Accountdata.Proprietor_Name : "",
          Mobile_Number: e?.Accountdata?.Mobile_Number ? e?.Accountdata?.Mobile_Number : "",
          Business_Mobile_Number: e?.Accountdata?.Business_Mobile_Number ? e?.Accountdata?.Business_Mobile_Number : "",
          Alternate_Mobile_Number: e?.Accountdata?.Alternate_Mobile_Number
            ? e?.Accountdata?.Alternate_Mobile_Number
            : "",
          Status: (
            <select
              name=""
              id=""
              style={{ height: "100%", width: "100%" }}
              onChange={(event) => handleStatusChange(e.SP_ID, event.target.value)}
            >
              <option value="Not Called" selected={e.Status === "Not Called" ? true : false}>
                Not Called
              </option>
              <option value="Call Back" selected={e.Status === "Call Back" ? true : false}>
                Call Back
              </option>
              <option value="Call Not Received" selected={e.Status === "Call Not Received" ? true : false}>
                Call Not Received
              </option>
              <option value="Not Interested" selected={e.Status === "Not Interested" ? true : false}>
                Not Interested
              </option>
            </select>
          ),
          Loads: (
            <a
              href="#"
              style={{ color: "blue", textDecoration: "none" }}
              onClick={() => handleOpenRelatedLoadModal(e.SP_ID)}
            >
              {" "}
              Loads
            </a>
          ),
          Bid_Now: (
            <a
              href="#"
              style={{ color: "blue", textDecoration: "none" }}
              onClick={() => handleBidModalfuc(e.SP_ID, e.SP_ID_Info.FullName)}
            >
              {" "}
              Bid Now
            </a>
          ),
          "Broker/Fleetowner": e?.Accountdata?.Transporter_Type ? e?.Accountdata?.Transporter_Type : "",
          "Directory/ Non-Directory": e?.Accountdata?.Directory_NonDirectory
            ? e?.Accountdata?.Directory_NonDirectory
            : "",
          KYC: e?.Accountdata?.KYC_Complete,
          verified: e?.Accountdata?.Is_Verified,
          Current_Status: e.Status,
        };

        return obj;
      });
      setRelatedSPs(modifiedData);
    }
    setLoading(false);
  }, [data]);
  // Closeformfunction2 A function to close the form/modal and clear any selected data.
  // It uses the `setShowModal` and `setOpenItems` function to manage visibility and uses Redux's `dispatch` to clear the data.
  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  // to perform an update operation (`editLoad` mutation) for the current load with the updated service providers statuses.
  // Uses the  `editLoad` mutation with variables containing the `LoadId and the array of service provider statuses (`allSpsStatus`).
  let submit = async () => {
    await editLoad({
      variables: {
        CreateInput: {
          LoadId: LoadId,
          RelatedSP: allSPsStatus,
        },
      },
    })
      .then((res) => {
        // dispatch({ type: "Refetch", payload: true });
        SuccessToast("Load Edited Sucess");
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };
  const isLoading = loading || loadingState || (!error && !RelatedSPs);

  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={"Search SP"}>
      <div className="mainResultDetailsdiv">
        {/* <div>
          <LoadDetails LoadId={LoadId} Type={"SearchSP"} />
        </div> */}
        {/* <div className="BiddingPage"> */}
        <div className=" SearchSPMaindiv">
          {/* Using LoadTable components to display related service providers (`RelatedSps`) and all the bids
          completed by service providers (allBidCompletedSPs). There's a condtion to check if ther's data available if not, it shows a "Data not Available Message"
           */}
          <div className="SearchSPData">
            <LoadTable
              data={RelatedSPs}
              loading={isLoading}
              error={error}
              title={"SearchSp_Main_Table"}
              selectedRows={selectedFirst}
              select={false}
            />
            
          </div>
          <div className="SearchSPData">
            {!allBidCompletedSPs?.length ? (
              <p style={{ textAlign: "center" }}>Data not Available</p>
            ) : (
              <LoadTable
                data={allBidCompletedSPs}
                loading={false}
                error={null}
                title={"SearchSp Sub Table"}
                selectedRows={combinedData}
                select={false}
              />
            )}
          </div>
        </div>
        {/* Opens when showBidModal is true. It's used for showing bid details for a service provider. */}
        {showBidModal && (
          <BidDetails
            show={showBidModal}
            LoadId={LoadId}
            setShowModal={() => setShowBidModal(!showBidModal)}
            fielddata={spId}
            totalWeight={undefined}
            TypeOfPortal={undefined}
          />
        )}
        {/* Triggered by showWarningmodal used for displaying warnings and possibly for triggering refecth actions */}
        {showWarningModal && (
          <WarningModal
            show={showWarningModal}
            getAllSP={() => handleRefetchAllSP()}
            loading={researchSPloading}
            setShowModal={() => setShowWarningModal(!showWarningModal)}
          />
        )}
        {/* Displayed when showRelatedLoadModal is true, showing related loads for a service provider */}
        {showRelatedLoadModal && (
          <SPRelatedLoads
            show={showRelatedLoadModal}
            RespId={RespId}
            LoadId={LoadId}
            setShowModal={() => setShowRelatedLoadModal(!showRelatedLoadModal)}
            fielddata={""}
            totalWeight={""}
            TypeOfPortal={""}
          />
        )}
      </div>
      {/* Contains action buttons for submitting the form, cancelling, or deleting actions. It has a `submitform` prop linked to the `submit` */}
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        submitType={"Save"}
        SaveAndClose={() => {
          submit();
          // Closeformfunction2();
        }}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
        handleFileDelete={() => setShowWarningModal(true)}
        TypeOfPortal={"SearchSP"}
      />
    </Reactportal>
  );
};

export default SearchSP;
